import { Dialog, DialogTitle, DialogContent, Radio, Button } from '@mui/material';
import React, { useState, useMemo } from 'react';
import { useMyContext } from '../../../context/MyContext';
import { RiMoneyRupeeCircleFill } from "react-icons/ri";
import { useNavigate } from 'react-router-dom';
import { IoIosCloseCircle } from "react-icons/io";
import Spinner from '../../../component/spinner/spinner';
import axios from 'axios';
import { toast } from 'react-toastify';
import '../../css/custom-scrollbar.css';
import { Base_Url, reverseShipment, createShippment } from '../../../config/config';
const ViewRateForword = ({ isopen, onClose, data, type }) => {
  const { isDarkMode } = useMyContext();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const userData = JSON.parse(localStorage.getItem('user')) || {};

  const handleNavigation = () => {
    navigate('/shipments/all');
  };

  // Dynamic table data generation with support for future partner additions
  const tableData = useMemo(() => {
    if (!data?.data?.partners_pricing) return [];

    // Collect all partners dynamically
    const allPartners = Object.keys(data.data.partners_pricing);

    // Flatten and transform pricing data for all partners
    return allPartners.flatMap(partner =>
      Object.entries(data.data.partners_pricing[partner] || {}).map(([mode, pricing], index) => ({
        id: `${partner}-${mode}-${index}`,
        courier: partner.toLowerCase(),
        mode,
        zone: data.data.zone,
        basePrice: pricing.total_price,
        codExtra: pricing.cod_extra,
        // Handling cases where cod_total_price might be 0
        codTotalPrice: pricing.cod_total_price !== 0
          ? pricing.cod_total_price
          : pricing.total_price,
        shippingMode: mode,
        // Spread any additional partner-specific data
        ...pricing
      }))
    );
  }, [data]);

  const handleRadioChange = (event, row) => {
    setSelectedRowId(row.id);
    setSelectedRowData(row);
  };

  const handleCreateShipment = async () => {
    const token = localStorage.getItem('token');
    const cusid = localStorage.getItem('cus_id');

    if (selectedRowData) {
      let requestBody;

      // Check if it's a bulk order
      if (data.bulk_order === true) {
        // For bulk orders, use array format with selected_orders
        requestBody = {
          order_id: data.selected_orders, // This should be an array like ['262819868300', '507837899536']
          shipping_mode: selectedRowData.shippingMode,
          partner: selectedRowData.courier
        };
      } else {
        // For single orders, use the original format
        requestBody = {
          order_id: data.order_id,
          partner: selectedRowData.courier,
          shipping_mode: selectedRowData.shippingMode
        };
      }

      setIsSubmitting(true);
      try {
        const response = await axios.post(Base_Url + createShippment, requestBody, {
          headers: {
            token,
            cus_id: cusid,
            'Content-Type': 'application/json',
          },
        });

        if (response.data.status === "SUCCESS") {
          const { summary, success_orders, failed_orders } = response.data;

          if (summary.failed === 0) {
            // All successful
            toast.success(`🎉 ${summary.success} shipment${summary.success > 1 ? 's' : ''} created successfully!`);
            handleClose();
            handleNavigation();
          } else if (summary.success === 0) {
            // All failed
            const errorMessages = failed_orders.map(order =>
              `❌ Order ${order.order_id}: ${order.message || "Unknown error"}`
            ).join('\n');
            toast.error(`Failed to create ${summary.failed} shipment${summary.failed > 1 ? 's' : ''}.\n${errorMessages}`);
          } else {
            // Mixed success/failure
            toast.info(`📊 ${summary.success} successful, ${summary.failed} failed out of ${summary.total} total shipments`);
            // failed_orders.forEach(order => {
            //   toast.error(`❌ Order ${order.order_id}: ${order.message || "Unknown error"}`);
            // });
            // toast.error(failed_orders.message);
            failed_orders.forEach(order => {
              const remarks =
                order?.response?.packages?.[0]?.remarks?.join(', ') ||
                order.message ||
                "Unknown error";

              toast.error(`❌ Order ${order.order_id}: ${remarks}`);
            });
          }
        } else {
          // General error case
          const errorMessage = Array.isArray(response.data.message)
            ? response.data.message.join(', ')
            : response.data.message || "An error occurred";
          toast.error(errorMessage);
        }

      } catch (error) {
        console.error("API Error:", error);
        toast.error(error.response?.data?.message || "An error occurred");
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const handleClose = () => {
    onClose();
  };

  const tableHeaders = useMemo(() => {
    const baseHeaders = [
      'Select',
      'Courier',
      'Mode',
      'Zone',
      'Forward Price',
      'COD Price',
      'Total Price'
    ];

    return baseHeaders;
  }, [tableData]);

  return (
    <Dialog
      open={isopen}
      onClose={onClose}
      maxWidth="md"
      className={`shadow-custom-light rounded-xl custom-scrollbar dark:shadow-custom-dark mt-4 ml-2 mr-2 mb-4 p-4 
        ${isDarkMode ? "dark:bg-darkmodeColor text-white" : ""}`}
      sx={{
        '& .MuiDialog-paper': {
          width: '80%',
          height: '65vh',
          backdropFilter: "blur(5px) sepia(5%)",
          borderRadius: "24px",
          display: 'flex',
          flexDirection: 'column'
        }
      }}
    >
      <DialogTitle className="bg-customPurple text-white text-center">
        <h2 className="text-sm font-semibold flex items-center justify-center">
          <RiMoneyRupeeCircleFill />
          Rate Calculator
        </h2>
        <IoIosCloseCircle
          className="absolute top-2 right-2 cursor-pointer"
          size={32}
          onClick={handleClose}
        />
      </DialogTitle>

      <DialogContent
        className={`shadow-custom-light rounded-custom dark:shadow-custom-dark mt-4 ml-2 mr-2 mb-4 p-4 
        ${isDarkMode ? "dark:bg-darkmodeColor text-white" : ""}`}
        sx={{ overflowY: 'auto' }}
      >
        <div className="overflow-x-auto md:mb-8 md:ml-8 md:mr-8">
          <table className="min-w-full table-auto overflow-y-auto mt-3">
            <thead className="bg-customPurple text-white text-[10px] dark:bg-darkmodeColor dark:text-white">
              <tr className='text-xs'>
                {tableHeaders.map((header, index) => (
                  <th key={index} className="px-1 py-2 text-left text-xs font-normal">{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tableData.length > 0 ? (
                tableData.map((row) => (
                  <tr key={row.id} className="border-b text-xs">
                    <td className="p-1">
                      <Radio
                        checked={selectedRowId === row.id}
                        onChange={(event) => handleRadioChange(event, row)}
                        value={row.id}
                        name="selectRow"
                        inputProps={{ 'aria-label': 'select row' }}
                        size="small"
                      />
                    </td>
                    <td>
                      {/* <div className="flex items-center mr-12"> */}
                      {row.courier?.toLowerCase() === "delhivery" && (
                        <img
                          src={isDarkMode ? "/assets/images/DELHIVERYWhite.png" : "/assets/images/Delhivery.png"}
                          alt="Delhivery"
                          className="h-[7px] w-auto object-contain"
                        />
                      )}
                      {row.courier?.toLowerCase() === "ecom" && (
                        <img
                          src={isDarkMode ? "/assets/images/logoecom.svg" : "/assets/images/ecom-express-logo.png"}
                          alt="Ecom Express"
                          className={`object-contain w-auto ${isDarkMode ? "h-2" : "h-10"}`}
                        />
                      )}
                      {row.courier?.toLowerCase() === "ekart" && (
                        <img
                          src="/assets/images/ekart.png"
                          alt="Ekart"
                          className="h-6 w-auto object-contain"
                        />
                      )}
                      {row.courier?.toLowerCase() === "xpressbees" && (
                        <img
                          src={isDarkMode ? "/assets/images/xpressbess.png" : "/assets/images/xpressbess.png"}
                          alt="XpressBees"
                          className="h-[10px] w-auto object-contain"
                        />
                      )}
                      {row.courier?.toLowerCase() === "bluedart" && (
                        <img
                          src={isDarkMode ? "/assets/images/bluedart.png" : "/assets/images/bluedart.png"}
                          alt="bluedart"
                          className="h-[10px] w-auto object-contain"
                        />
                      )}
                      {!["delhivery", "ecom", "ekart", "xpressbees", "bluedart"].includes(row.courier?.toLowerCase()) && (
                        <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200">
                          {row.courier}
                        </span>
                      )}
                      {/* </div> */}
                    </td>
                    <td className="p-1 text-left font-medium">{row.mode || "N/A"}</td>
                    <td className="p-1 text-left font-medium">{row.zone || "N/A"}</td>
                    <td className="p-1 text-left font-medium">{row.basePrice ? `₹ ${row.basePrice}` : "N/A"}</td>
                    <td className="p-1 text-left font-medium">{row.codExtra ? `₹ ${row.codExtra}` : "N/A"}</td>
                    <td className="p-1 text-left font-medium">{row.codTotalPrice ? `₹ ${row.codTotalPrice}` : "N/A"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="p-1 text-center text-xs" colSpan={tableHeaders.length}>
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </DialogContent>

      <div className="flex justify-end">
        <button
          className="text-lg md:texl-sm w-[80%] md:w-[20%] font-bold mb-4 sm:mb-6 bg-customPurple hover:bg-purple-700 dark:bg-customPurple dark:hover:bg-purple-700 text-white font-sans rounded h-[40px] flex items-center justify-center mr-3"
          onClick={handleCreateShipment}
          disabled={!selectedRowId || isSubmitting}
        >
          {isSubmitting ? <Spinner /> : (type === "reverse" ? "Reverse Shipment" : "Create Shipment")}
        </button>
      </div>
    </Dialog>
  );
};

export default ViewRateForword;
